const ENV = {
  API_URL: import.meta.env.VITE_API_URL,
  API_KEY: import.meta.env.VITE_API_KEY,
  GOOGLE_MAP_KEY: import.meta.env.GOOGLE_MAP_KEY
}

export default ENV
